//#region Libraries
import styled from "styled-components";
//#endregion

export const Container = styled.div`
    color: var(--light-gray-5);
    font-size: 14px;
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    column-gap: 40px;
    max-height: 150px;
    margin: 0;
    @media (max-width: 945px) {
        max-height: unset;
    }
`;